var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.842,
    height: 16,
    viewBox: "0 0 16.842 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0f3;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7.966.994a.5.5,0,0,1,.909,0l1.912,4.179a.5.5,0,0,0,.4.289l4.569.525a.5.5,0,0,1,.281.865L12.649,9.958a.5.5,0,0,0-.152.468l.912,4.5a.5.5,0,0,1-.736.535L8.667,13.2a.5.5,0,0,0-.491,0L4.169,15.463a.5.5,0,0,1-.736-.535l.912-4.5a.5.5,0,0,0-.152-.468L.807,6.852a.5.5,0,0,1,.281-.865l4.569-.525a.5.5,0,0,0,.4-.289Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteIcon);
export default __webpack_public_path__ + "static/media/favorite-icon.8c8489b03b7e142ffea86a40909ed9bd.svg";
export { ForwardRef as ReactComponent };